(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function openFromHash() {
      if (!location.hash) return;
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (!target || !target.classList.contains('faq-content__question')) return;
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }
    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
